/**
 * Custom fetch function to get transport zones from the Transport API.
 */
export const getTransportZone = async (
	address: string,
	regionCode: string,
): Promise<{ zone: string }> => {
	const url = import.meta.env.VITE_TRANSPORT_API_URL;

	if (!url) {
		throw new Error("Transport API URL is not defined.");
	}

	const response = await fetch(
		`${url}/zone?code=${encodeURIComponent(regionCode)}&address=${encodeURIComponent(address)}`,
	);

	if (!response.ok) {
		throw new Error("Failed to fetch transport zones.");
	}

	return response.json();
};
